import React from 'react';
import { useUsers } from './hooks';
import UsersContent from './UsersContent';
import { UserModal, UserDetailModal } from '.';

interface UsersContainerProps {
  confirmDialog: {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
  };
  setConfirmDialog: (dialog: { isOpen: boolean; title: string; message: string; onConfirm: () => void }) => void;
}

const UsersContainer: React.FC<UsersContainerProps> = ({ confirmDialog, setConfirmDialog }) => {
  const {
    users,
    loading,
    showUserModal,
    editingUser,
    selectedUser,
    showUserDetailModal,

    currentPage,
    totalPages,
    totalCount,
    showingFrom,
    showingTo,
    handlePageChange,

    searchQuery,
    handleSearchChange,

    handleCreateUser: _handleCreateUser,
    handleEditUser,
    handleDeleteUser,
    handleDisableUser,
    handleEnableUser,
    handleSaveUser,
    handleViewUserDetail,

    setShowUserModal,
    setShowUserDetailModal
  } = useUsers(confirmDialog, setConfirmDialog);

  return (
    <div className='flex h-full flex-col'>
      <UsersContent
        users={users}
        loading={loading}
        onEditUser={handleEditUser}
        onDeleteUser={handleDeleteUser}
        onDisableUser={handleDisableUser}
        onEnableUser={handleEnableUser}
        onViewUserDetail={handleViewUserDetail}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        showingFrom={showingFrom}
        showingTo={showingTo}
        onPageChange={handlePageChange}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
      />

      {showUserModal && (
        <UserModal isOpen={showUserModal} onClose={() => setShowUserModal(false)} onSave={handleSaveUser} editingUser={editingUser} />
      )}

      {showUserDetailModal && selectedUser && (
        <UserDetailModal isOpen={showUserDetailModal} onClose={() => setShowUserDetailModal(false)} user={selectedUser} />
      )}
    </div>
  );
};

export default UsersContainer;
